import React from 'react';
import { Link, router, useForm, usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { useTrans } from '../../hooks/useTrans';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function Login() {
    const translate = useTrans();
    const { flash, developerLogin } = usePage().props;

    const { data, setData, post, processing, errors } = useForm({
        username: '',
        password: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post('/login');
    }

    return (
        <>
            <AuthPanel>
                {flash && flash.type === 'error' && (
                    <Alert variant="error">
                        <strong>{flash.description}</strong>
                        {flash.errors && flash.errors.length > 0 && (
                            <ul className="mt-1 list-disc pl-4">
                                {flash.errors.map((error, i) => error && <li key={i}>{error}</li>)}
                            </ul>
                        )}
                    </Alert>
                )}

                {flash && flash.type === 'success' && (
                    <Alert variant="success">{flash.description}</Alert>
                )}

                {(errors.username || errors.password) && (
                    <Alert variant="error">
                        <strong>{translate('Inloggen mislukt')}</strong>
                        <ul className="mt-1 list-disc pl-4">
                            {errors.username && <li>{errors.username}</li>}
                            {errors.password && <li>{errors.password}</li>}
                        </ul>
                    </Alert>
                )}

                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('E-mailadres of gebruikersnaam')} *
                            </label>
                            <Input
                                value={data.username}
                                onChange={(e) => setData('username', e.target.value)}
                                placeholder={translate('E-mailadres of gebruikersnaam')}
                                required
                                className="h-[44px] font-normal"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('Wachtwoord')} *
                            </label>
                            <Input
                                type="password"
                                value={data.password}
                                onChange={(e) => setData('password', e.target.value)}
                                placeholder={translate('Wachtwoord')}
                                required
                                className="h-[44px] font-normal"
                            />
                        </div>

                        <Button variant="primary" type="submit" disabled={processing} className="w-full">
                            {translate('Inloggen')}
                        </Button>
                    </div>
                </form>

                {developerLogin && (
                    <div className="mt-4 space-y-2">
                        {developerLogin.accounts.map((account) => (
                            <Button
                                key={account.username}
                                variant="primary-outline"
                                type="button"
                                className="w-full"
                                onClick={() => router.post(developerLogin.url, { username: account.username })}
                            >
                                {translate('Inloggen als :name', { name: account.label })}
                            </Button>
                        ))}
                    </div>
                )}
            </AuthPanel>

            <Link href="/forgotpassword" className="mt-4 block text-center text-sm text-white/60 no-underline hover:text-white">
                {translate('Wachtwoord vergeten')}
            </Link>
        </>
    );
}
